import { TIMER_PAGINATION_SUCCESS, TIMER_PAGINATION_FAILURE } from "../constants/timerConstants";

export const initialState = {
    data: [],
    error: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TIMER_PAGINATION_SUCCESS:
            return { ...state, data: action?.data, error: null };
        case TIMER_PAGINATION_FAILURE:
            return { ...state, error: action.error };
        default:
            return state;
    }
}
